import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function Series3() {
  return (
    <BackgroundWrapper>
      
      <div className="pt-8 pb-20 px-4 min-h-screen">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/enlightened-leadership"
            className="text-blue-600 hover:text-blue-700 font-semibold inline-flex items-center mb-8"
          >
            ← Back to Enlightened Leadership
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-10 md:p-16">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
              Series 3 – Purpose and Personal Growth
            </h1>

            <p className="sm:text-lg text-sm text-slate-700 mb-6 leading-relaxed">
              The final series guides leaders to move from success to significance 
              by connecting their inner passion to purposeful action. Participants 
              reflect on their current position, redefine their impact trajectory, 
              and reset personal and professional priorities to make a meaningful 
              difference in their world.
            </p>

            <h2 className="sm:text-lg text-sm font-semibold text-slate-800 mb-4">Content</h2>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Part 1 – The World and I</li>
              <li>Part 2 – The Inner Hero</li>
              <li>Part 3 – Happiness and the Meaning of Life</li>
            </ul>

            <p className="text-slate-700 leading-relaxed mb-4 sm:text-lg text-sm">
              Participants undertake a transformative reflection on purpose,
              legacy, and contribution, supported by individual and group coaching. 
              The experience reignites motivation and channels it into concrete, 
              value-driven initiatives that leave a lasting mark.
            </p>

            <p className="text-slate-600 text-sm">
              <strong>Method:</strong> Seminar  ·  Group Coaching  ·  Selected Individual Coaching
            </p>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
